import { render, staticRenderFns } from "./SideBarMenu.vue?vue&type=template&id=f5113f16&scoped=true&"
import script from "./SideBarMenu.vue?vue&type=script&lang=js&"
export * from "./SideBarMenu.vue?vue&type=script&lang=js&"
import style0 from "./SideBarMenu.vue?vue&type=style&index=0&id=f5113f16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5113f16",
  null
  
)

export default component.exports